/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectPagedData } from '../../models/project-paged-data';

export interface GetProjects$Params {
  PageNumber?: number;
  PageSize?: number;
}

export function getProjects(http: HttpClient, rootUrl: string, params?: GetProjects$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectPagedData>> {
  const rb = new RequestBuilder(rootUrl, getProjects.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectPagedData>;
    })
  );
}

getProjects.PATH = '/project';
